import { render, staticRenderFns } from "./BadgePill.vue?vue&type=template&id=508d9fea"
import script from "./BadgePill.vue?vue&type=script&lang=js"
export * from "./BadgePill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports